import './App.css';
import { Home } from './pages/Home/Home';
import { Route, Routes, Navigate } from 'react-router-dom';
import { Contactus } from './pages/Contactus/contactus';
import { Ebook } from './pages/Ebook/Ebook';
import { Login } from './pages/Login/login';
import { Team } from './pages/Team/team';
import Listing from './pages/Listing/listing';
import MetaPixelTracker from './components/MetaPixelTracker/MetaPixelTracker';
import { Landlords } from './pages/Landlords/Landlords';
import ServiceRequest from './pages/serviceRequest/ServiceRequest';
import { ConfirmProperty } from './pages/confirmProperty/ConfirmProperty';
import { TenentHandbook } from './pages/TenentHandbook/TenentHandbook';
import { BecomeATenent } from './pages/BecomeATenent/BecomeATenent';
import { SubletAgreement } from './pages/SubletAgreement/SubletAgreement';
import { N9 } from './pages/N9/N9';
import { ScheduleShowing } from './pages/ScheduleShowing/ScheduleShowing';
import PropertyView from './pages/SinglePropertyView/PropertyView';
import Thankyou from './pages/Thankyou/Thankyou';
import ThankYou from './pages/Thank-You/ThankYou';
import AddEvent from './pages/CalenderEvents/AddEvent';
import Admin from './pages/Admin/Index';
import ListCalenderEvent from './pages/CalenderEvents/ListCalenderEvent';
import UpdateEvent from './pages/CalenderEvents/UpdateEvent';
import LoginForm from './pages/Admin/Login';
import AdminHome from './pages/Admin/AdminHome';
import Title from './pages/Admin/Title';
import Faq from './pages/FAQ/Faq';
import ApptAllShowings from './pages/Appoinment/AllShowings'
import ApptSingleShowing from './pages/Appoinment/SingleShowing'
import { NotFound } from './pages/404/NotFound';
import { Laloma } from './pages/Laloma/Laloma';
import NoticeToEnterForm from './pages/Admin/NoticeToEnter';


function App() {
  return (
    <>
      {/* Global Meta Pixel tracker that conditionally renders based on routes */}
      <MetaPixelTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="contactus" element={<Contactus />} />
        <Route path="ebook" element={<Ebook />} />
        <Route path="ebook/thankyou" element={<Thankyou />} />
        <Route path="login" element={<Login />} />
        <Route path="team" element={<Team />} />
        <Route path="listing" element={<Listing />} />
        <Route path="listing/laloma" element={<Laloma />} />
        <Route path="listing/:id" element={<PropertyView />} />
        <Route path="Landlords" element={<Landlords />} />
        <Route path="ServiceRequest" element={<ServiceRequest />} />
        <Route path="ConfirmProperty/:id" element={<ConfirmProperty />} />
        <Route path="TenantHandbook" element={<TenentHandbook />} />
        <Route path="BecomeATenent" element={<BecomeATenent />} />

        <Route path="SubletAgreement" element={<SubletAgreement />} />
        <Route path="TenantTenancy" element={<N9 />} />
        <Route path="ScheduleShowing" element={<ScheduleShowing />} />
        <Route path='thankyou' element={<ThankYou />} />

        <Route path='/FAQ' element={<Faq />} />

        <Route path='/admin' element={<Admin />} >
          <Route path='/admin' element={<LoginForm />} />
          <Route path='/admin/add-title' element={<Title />} />
          <Route path='/admin/nte' element={<NoticeToEnterForm />} />
          <Route path='/admin/dashboard' element={<AdminHome />} />
          <Route path='/admin/add-event' element={<AddEvent />} />
          <Route path='/admin/event-list' element={<ListCalenderEvent />} />
          <Route path='/admin/update-event/:id' element={<UpdateEvent />} />
          <Route path='/admin/appointment' element={<ApptAllShowings />} />
          <Route path='/admin/attendees' element={<ApptSingleShowing />} />
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
